import React from 'react'
import { Popover, Box, Typography, Divider, FormGroup, FormControlLabel, Checkbox, Stack, Button } from '@mui/material'
import { Settings as SettingsIcon } from '@mui/icons-material'
import type { ColumnDef } from './types'

interface ColumnConfigPopoverProps {
  open: boolean
  anchorEl: HTMLElement | null
  onClose: () => void
  columns: ColumnDef[]
  columnConfig: Record<string, boolean>
  onChange: (columnKey: string, checked: boolean) => void
  onShowAll: () => void
  onShowEssentials: () => void
}

const ColumnConfigPopover: React.FC<ColumnConfigPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  columns,
  columnConfig,
  onChange,
  onShowAll,
  onShowEssentials
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <Box sx={{ p: 2, minWidth: 250 }}>
        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SettingsIcon fontSize="small" />
          إعدادات الأعمدة
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <FormGroup>
          {columns.map((column) => (
            <FormControlLabel
              key={column.key}
              control={
                <Checkbox
                  checked={!!columnConfig[column.key]}
                  onChange={(e) => onChange(column.key, e.target.checked)}
                  disabled={column.key === 'product_name' || column.key === 'total'}
                />
              }
              label={column.label}
            />
          ))}
        </FormGroup>
        <Divider sx={{ my: 2 }} />
        <Stack direction="row" spacing={1}>
          <Button size="small" variant="outlined" onClick={onShowAll}>
            إظهار الكل
          </Button>
          <Button size="small" variant="outlined" onClick={onShowEssentials}>
            الأساسيات فقط
          </Button>
        </Stack>
      </Box>
    </Popover>
  )
}

export default ColumnConfigPopover
